import escape from 'escape-string-regexp'
export {escape}

/**
 * Compile a regular expression, handling the u and x flags.
 */
export function compile(patt, flags = '') {
  // Eliminate the 'u' flag in non-supporting browsers (IE 11).
  if (!('unicode' in RegExp.prototype)) {
    flags = flags.replace(/u/g, '')
  }

  if (flags.includes('x')) {
    flags = flags.replace(/x/g, '')

    // Remove comments. This is slightly different from spec because it treats
    // # as the comment character if it is preceded by whitespace, even if it's
    // inside a character class.
    patt = patt.replace(/\s#.*$/gm, '')

    // Remove internal whitespace, unless backslack-escaped. This uses
    // a capturing forward lookahead to avoid catastrophic backtracking.
    // https://wanago.io/2019/09/23/regex-course-part-four-avoiding-catastrophic-backtracking-using-lookahead/
    patt = patt.replace(/(?:(?=(\\))(?:\1( )|(\1.))|\s)/gs, '$2$3')
  }

  return new RegExp(patt, flags)
}

/**
 * Compile a regular expression from a tagged template literal.
 */
export function tag(...args) {
  let flags = args[0] || ''
  if (Array.isArray(flags)) {
    return tag()(...args)
  }
  return function (strings, ...values) {
    let patt = strings.raw[0]
    values.forEach((v, i) => {
      patt += (v?.source ?? v ?? '') + strings.raw[i + 1]
    })
    return compile(patt, flags)
  }
}
